export const IS_NUMBER_REGEX = /^[0-9]+$/;
